export class AnnouncementPolicy {
    user;
    constructor(container) {
        this.user = container.user;
    }
    allowsDelete(announcement) {
        if (!this.user) {
            return false;
        }
        if (this.user?.isAdmin) {
            return true;
        }
        return announcement.createdById === this.user.id ? true : false;
    }
}
//# sourceMappingURL=AnnouncementPolicy.js.map